
import { constructManualSortingComputedProperty } from "@/utils/manualSort"

export default ({ columns, variables, key, dataSource, orderSource, sortSource }) => {
  key = 'simple-reordering-order:' + key

  if (!orderSource) orderSource = 'order'
  if (!sortSource) sortSource = 'sort'

  let order = localStorage.getItem(key)
  if (order) order = JSON.parse(order)
  else order = null

  return {
    data() {
      return {
        customOrder: order || columns,
        [sortSource]: null,
        [orderSource]: "asc",

        timeout: null,
      }
    },
    methods: {
      updateColumnOrder(ids) {
        this.customOrder = ids || []
      },
      setSort(sort) {
        this[sortSource] = sort
      },
      setOrder(order)  {
        if (this.timeout) {
          clearTimeout(this.timeout)
        }

        this.timeout = setTimeout(() => this[orderSource] = order, 200)
      }
    },
    computed: {
      sortedOrderingData: constructManualSortingComputedProperty(dataSource, sortSource, orderSource),
      indexMap() {
        return this.customOrder.map(id => columns.indexOf(id))
      },
      columns() {
        return this.customOrder.map(id => columns[columns.indexOf(id)])
      },
      variables() {
        return this.indexMap.map(index => variables[index])
      },
    },
    watch: {
      customOrder(order) {
        localStorage.setItem(key, JSON.stringify(order))
      },
    },
  }
}
